(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-section2"] && !window.DesignMode) return;
  try {
    
if (window.matchMedia("(max-width: 767px)").matches) 
        {
           $('.dscription').hide();
          $('svg#Capa_1').click(function(){
          $(this).toggleClass('rotate');
          $(this).parent().parent().next().toggle();
      }) 
            
        } 



  } catch(e) { console.error(e); }
})();
})();
